import { SwiperProps } from 'swiper/react';

import { SpacingUnit, spacingUnitToPixels } from '../Spacing';

const BREAKPOINTS: SwiperProps['breakpoints'] = {
  1340: {
    slidesPerView: 5,
  },
  1150: {
    slidesPerView: 4,
  },
  950: {
    slidesPerView: 3,
  },
};

export const SUMMARY_INDICATORS_SLIDER_PARAMS = {
  SLIDES_PER_VIEW: 2,
  BREAKPOINTS,
  SPACE_BETWEEN: spacingUnitToPixels(SpacingUnit.unit5),
};
